import { CHECKOUT_ITEM_TYPE_TOUR_V2 } from 'constants/checkout'
import { dateDifference } from 'lib/datetime/dateUtils'
import uuidV4 from 'lib/string/uuidV4Utils'

function generateTourV2CheckoutItem(
  offer: App.Tours.TourV2Offer,
  departure: App.Tours.TourV2OfferDeparture,
  travellers: App.Occupants,
  purchasableOption: App.Tours.TourV2OfferPurchasableOption,
  purchasableOptionConfirmed?: boolean,
): App.Checkout.TourV2Item {
  const { startDate, endDate } = departure
  const variation = offer.variations[departure.fkVariationId]
  const { days } = dateDifference(new Date(endDate), new Date(startDate))

  return {
    startDate,
    endDate,
    occupancy: travellers,
    image: variation.images[0],
    purchasableOption,
    offerId: offer.id,
    duration: days + 1,
    itemId: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_TOUR_V2,
    transactionKey: uuidV4(),
    privateRequestKey: offer.privateRequestKey,
    total: purchasableOption.price * travellers.adults,
    memberTotal: purchasableOption.memberPrice * travellers.adults,
    purchasableOptionConfirmed,
  }
}

export default generateTourV2CheckoutItem
